import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

import { TradingOfferOperationStatusHistory } from 'types/TradingOfferOperation';

import { activityAvatarMap } from '../../../constants/tradingOfferOperationStatus';

const formatDateTime = (date: Date | string | undefined) => {
  if (!date) return '-';
  return format(new Date(date), "dd MMM yyyy · HH:mm'h'", { locale: es });
};

type TradingOfferOperationDetailActivityHistoryProps = {
  statusHistory: TradingOfferOperationStatusHistory[];
};

const TradingOfferOperationDetailActivityHistory: FC<
  TradingOfferOperationDetailActivityHistoryProps
> = ({ statusHistory }) => {
  const { t } = useTranslate();

  return (
    <div className="nk-block">
      <div className="card card-bordered">
        <div className="card-inner">
          <h6 className="card-title mb-3">
            <em className="icon ni ni-activity-round text-primary mr-2" />
            {t('ActivityHistory')}
          </h6>
          {statusHistory?.length ? (
            <ul className="list-unstyled mb-0">
              {statusHistory.map((entry, idx) => {
                const isLast = idx === statusHistory.length - 1;
                const avatar = activityAvatarMap[entry.status] || activityAvatarMap.PENDING;

                return (
                  <li
                    key={entry.status}
                    className={`d-flex align-items-start py-3 ${
                      !isLast ? 'border-bottom' : ''
                    }`}
                  >
                    <div
                      className={`user-avatar user-avatar-xs ${avatar.bg} mr-3 mt-1`}
                    >
                      <em className={`icon ni ${avatar.icon}`} />
                    </div>
                    <div className="flex-grow-1">
                      <div className="d-flex justify-content-between">
                        <strong className="fs-13px">{t(entry.status)}</strong>
                        <span className="text-soft fs-12px">
                          {formatDateTime(entry.date)}
                        </span>
                      </div>
                      {entry.comment && (
                        <p className="text-soft fs-13px mb-0">
                          {entry.comment}
                        </p>
                      )}
                    </div>
                  </li>
                );
              })}
            </ul>
          ) : (
            <p className="text-soft fs-13px mb-0">{t('NoActivityHistory')}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default TradingOfferOperationDetailActivityHistory;
